import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\FetchDocumentHeadersController::__invoke
* @see app/Http/Controllers/Document/FetchDocumentHeadersController.php
* @route '/api/document-headers'
*/
const FetchDocumentHeadersController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDocumentHeadersController.url(options),
    method: 'get',
})

FetchDocumentHeadersController.definition = {
    methods: ["get","head"],
    url: '/api/document-headers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\FetchDocumentHeadersController::__invoke
* @see app/Http/Controllers/Document/FetchDocumentHeadersController.php
* @route '/api/document-headers'
*/
FetchDocumentHeadersController.url = (options?: RouteQueryOptions) => {
    return FetchDocumentHeadersController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\FetchDocumentHeadersController::__invoke
* @see app/Http/Controllers/Document/FetchDocumentHeadersController.php
* @route '/api/document-headers'
*/
FetchDocumentHeadersController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDocumentHeadersController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\FetchDocumentHeadersController::__invoke
* @see app/Http/Controllers/Document/FetchDocumentHeadersController.php
* @route '/api/document-headers'
*/
FetchDocumentHeadersController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDocumentHeadersController.url(options),
    method: 'head',
})

export default FetchDocumentHeadersController